import React, { useState } from 'react';

interface TooltipProps {
  content: string;
  children: React.ReactNode;
  position?: 'top' | 'right' | 'bottom' | 'left' | 'top-right' | 'top-left' | 'bottom-right' | 'bottom-left';
}

export const Tooltip = ({ content, children, position = 'top' }: TooltipProps) => {
  const [isVisible, setIsVisible] = useState(false);

  const positionClasses = {
    top: 'bottom-full left-1/2 -translate-x-1/2 mb-2',
    right: 'left-full top-1/2 -translate-y-1/2 ml-2',
    bottom: 'top-full left-1/2 -translate-x-1/2 mt-2',
    left: 'right-full top-1/2 -translate-y-1/2 mr-2',
    'top-right': 'bottom-full right-0 mb-2', // 右端揃え、上
    'top-left': 'bottom-full left-0 mb-2', // 左端揃え、上
    'bottom-right': 'top-full right-0 mt-2', // 右端揃え、下
    'bottom-left': 'top-full left-0 mt-2' // 左端揃え、下
  };

  return (
    <div className="relative cursor-default">
      <div onMouseEnter={() => setIsVisible(true)} onMouseLeave={() => setIsVisible(false)}>
        {children}
      </div>

      {isVisible && (
        <div
          className={`
            absolute z-10 px-3 py-2
            bg-gray-800 text-white
            text-sm rounded-lg shadow-lg
            whitespace-nowrap
            ${positionClasses[position]}
          `}>
          {content}
        </div>
      )}
    </div>
  );
};

export default Tooltip;
